<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <div class="flex items-center">
          <el-image style="width: 16px; height: 16px" :src="home" />
          <span class="font-20 font-weight"
            :style="style ? 'color: #FFFFFF' : 'color:#666666'"
            style="margin-left: 6px; font-weight: 400"
          >
           {{'首页 >'}}
          </span> 
        </div>
      </el-breadcrumb-item>
      <el-breadcrumb-item >
        <div class="flex items-center">
          <span class="font-20 font-weight"
            :style="style ? 'color: #FFFFFF' : 'color:#666666'"
            style="margin-left: 6px; font-weight: 400"
          >
            {{ title }} 
          </span> 
        </div>
      </el-breadcrumb-item>
      <!-- <el-breadcrumb-item :to="{ path: dataInfo.link }">
        <span
          :style="style ? 'color: #FFFFFF' : 'color:#666666'"
          style="margin-left: 6px; font-weight: 400"
        >
          {{ dataInfo.fullName }}
        </span>
      </el-breadcrumb-item>
      <template v-for="(item, index) in dataInfo.children">
        <el-breadcrumb-item v-if="item.code === codes" :key="index" :to="{ path: item.link }">
          <span
            :style="style ? 'color: #FFFFFF' : 'color:#666666'"
            style="margin-left: 6px; font-weight: 400"
          >
            {{ item.fullName }}
          </span>
        </el-breadcrumb-item>
      </template> -->
    </el-breadcrumb>
  </div>
</template>
<script>
  import home from "../../assets/image/base/home.png";

  export default {
    name: "Breadcrumb",
    props: {
      title: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        home,
        style: false,
        dataInfo: {},
        codes: "",
      };
    },
    mounted() {
      // 初始化时执行一次样式设置
      this.updateStyleByPath(this.$route.path);
    },
    watch: {
      "$route.path": {
        handler(newPath, oldPath) {
          console.log("路径变化:", oldPath, "->", newPath);
          this.updateStyleByPath(newPath);
        },
        immediate: false,
      },
    },
    methods: {
      updateStyleByPath(path) {
        if (path === "/" || path === "/aboutIndex" || path === "/Scenicspot") {
          this.style = true;
        } else {
          this.style = false;
        }
      },
      show(code) {
        if (code === "details") return;
        let data = localStorage.getItem("nav");
        let list = [];
        if (data) {
          list = JSON.parse(data);
        }
        let path = this.findCodePath(list, code);
        console.log(path, 66627);
        if (path && path.length) {
          this.dataInfo = path[0];
        }
        this.codes = code;
        console.log(this.dataInfo, this.codes);
      },
      findCodePath(data, targetCode) {
        const search = (node) => {
          if (node.code === targetCode) {
            return [node];
          }
          if (node.children) {
            for (const child of node.children) {
              const result = search(child);
              if (result) return [node, ...result];
            }
          }
          return null;
        };
        for (const item of data) {
          const result = search(item);
          if (result) return result;
        }
        return null;
      },
    },
  };
</script>

<style scoped>
  .el-icon-arrow-right {
    color: #fff;
  }
  ::v-deep .el-breadcrumb__separator {
    display: none !important;
  }
</style>
